export default "__VITE_ASSET__BErrlxDp__"